import VectorSource from "ol/source/Vector.js";
import VectorLayer from "ol/layer/Vector.js";
import { styleFunction } from "./layerStyles";
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ.js";
import { tileGrid, projection, backgroundMapUrl } from "./config";

export const backgroundMapLayer = new TileLayer({
  title: "AGS REST XYZ Tiled",
  visible: true,
  source: new XYZ({
    url: backgroundMapUrl,
    tileGrid: tileGrid,
    projection: projection,
  }),
});

// Source and layer for the geometries drawn on the map
export const markerSource = new VectorSource();
export const markerLayer = new VectorLayer({
  source: markerSource,
  style: styleFunction,
  name: "markerLayer",
});